<div class="language-switcher">
  <div title="Hrvatski" (click)="onCroatianClick()">
    <img src="../assets/images/Croatia.png" alt="Hrvatski" />
  </div>
  <div title="English" (click)="onEnglishClick()" class="english">
    <img src="../assets/images/English.png" alt="English" />
  </div>
</div>
<router-outlet></router-outlet>
